// eslint-disable-next-line import/prefer-default-export
export function useSessionActivityChangeRequest() {
  function mapChangeRequestData(requestData, mappingObject = {
    sessionStartTime: 'startTimestamp',
    sessionFinishTime: 'endTimestamp',
  }) {
    return Object.entries(mappingObject).reduce((acc, [key, value]) => {
      acc[key] = requestData[value];
      return acc;
    }, {});
  } // mapChangeRequestData

  /**
   * `getUpdatedSessionNoteFields()` reads the entered times in preference to the session ones, so on
   * approval the times the staff member entered earlier would win over the ones just approved and the
   * activity would keep its old time frame. They are dropped for that calculation only — the field data
   * that gets stored keeps them.
   *
   * @param {Object} sessionNotesFieldData
   * @return {Object}
   */
  function getFieldDataForApproval(sessionNotesFieldData) {
    return {
      ...sessionNotesFieldData,
      session: {
        ...sessionNotesFieldData?.session,
        enteredStartTime: null,
        enteredFinishTime: null,
      },
    };
  } // getFieldDataForApproval

  return {
    mapChangeRequestData,
    getFieldDataForApproval,
  };
}
